import React from 'react';
import { Link } from 'react-router-dom';

const SignupSuccess = () => {
  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', padding: '2rem', textAlign: 'center' }}>
      <div style={{ 
        backgroundColor: '#4caf50', 
        color: 'white', 
        padding: '2rem', 
        borderRadius: '8px',
        marginBottom: '2rem'
      }}>
        <h1 style={{ margin: '0 0 1rem 0' }}>🎉 Registration Successful!</h1>
        <p style={{ margin: 0, fontSize: '1.1rem' }}>
          Your clinic has been successfully registered with MedInsight PRO.
        </p>
      </div>
      
      <div style={{ 
        backgroundColor: '#f5f5f5', 
        padding: '1.5rem', 
        borderRadius: '8px',
        marginBottom: '2rem',
        textAlign: 'left'
      }}>
        <h3 style={{ margin: '0 0 1rem 0' }}>What happens next?</h3>
        <ul style={{ paddingLeft: '1.5rem', lineHeight: '1.6' }}>
          <li>Your account is currently <strong>pending approval</strong></li>
          <li>An administrator will review and approve your account</li>
          <li>You'll receive an email notification once approved</li>
          <li>If you provided a Pabau API key, we'll begin syncing your data after approval</li>
        </ul>
      </div>

      <div style={{ 
        backgroundColor: '#e3f2fd', 
        padding: '1.5rem', 
        borderRadius: '8px',
        marginBottom: '2rem'
      }}>
        <h3 style={{ margin: '0 0 1rem 0' }}>Need help?</h3>
        <p style={{ margin: 0 }}>
          If you have any questions or need assistance, please contact our support team.
        </p>
      </div>

      <Link 
        to="/login" 
        style={{ 
          display: 'inline-block',
          backgroundColor: '#3f51b5', 
          color: 'white', 
          padding: '0.75rem 2rem',
          borderRadius: '4px',
          textDecoration: 'none',
          fontWeight: 'bold'
        }}
      >
        Go to Login
      </Link>
    </div>
  );
};

export default SignupSuccess; 